import { API_BASE_URL } from "../constants";

// Global configuration
const config = {
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
};

window.HTTPConfig = config;

// Helper to build full URL
const buildUrl = (url) => {
  if (url.startsWith("http")) return url;
  const base = config.baseURL.endsWith("/") ? config.baseURL : `${config.baseURL}/`;
  const path = url.startsWith("/") ? url.slice(1) : url;
  return `${base}${path}`;
};

// Core fetch wrapper
const fetchWrapper = async (url, options = {}) => {
  const fullUrl = buildUrl(url);

  const fetchOptions = {
    credentials: "include",
    headers: {
      ...config.headers,
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(fullUrl, fetchOptions);

    // Parse JSON response
    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    }

    // Handle HTTP errors
    if (!response.ok) {
      return Promise.reject({
        response: {
          status: response.status,
          data: data || { message: `HTTP Error ${response.status}` },
        },
      });
    }

    // Return axios-like response structure
    return {
      data,
      status: response.status,
      statusText: response.statusText,
    };
  } catch (error) {
    // Network error
    if (error.response) {
      return Promise.reject(error);
    }
    return Promise.reject({
      response: { data: { message: "Error: Network Error" } },
    });
  }
};

export const setBearer = (token) => {
  config.headers.Authorization = `bearer ${token}`;
};

export const setBaseUrl = (url) => {
  config.baseURL = url;
};

export const url2data = async (url, params, method) => {
  let response;
  if (params) {
    if (method === "PUT") {
      response = await fetchWrapper(url, {
        method: "PUT",
        body: JSON.stringify(params),
      });
    } else if (method === "PATCH") {
      response = await fetchWrapper(url, {
        method: "PATCH",
        body: JSON.stringify(params),
      });
    } else if (method === "DELETE") {
      response = await fetchWrapper(url, {
        method: "DELETE",
      });
    } else {
      response = await fetchWrapper(url, {
        method: "POST",
        body: JSON.stringify(params),
      });
    }
  } else {
    response = await duplicateGetStopper.get(url);
  }
  const { data } = response;
  return data;
};

export const fetchData = (url) =>
  fetchWrapper(url, { method: "GET" }).then((response) => response.data?.data);

export const patchData = (url, data) =>
  fetchWrapper(url, {
    method: "PATCH",
    body: JSON.stringify(data),
  }).then((response) => response.data?.data);

export const deleteData = (url) =>
  fetchWrapper(url, { method: "DELETE" });

export const updateData = (data, url) => {
  if (data?.id) {
    const { id, ...newData } = data;
    return url2data(`${url}/${id}`, newData, "PUT");
  }
  return url2data(url, data);
};

class DuplicateGetStopper {
  constructor() {
    this.cache = {};
  }

  get(url) {
    if (!url) return Promise.reject(new Error("Url not passed"));
    if (this.cache[url]) return this.cache[url];

    this.cache[url] = fetchWrapper(url, { method: "GET" })
      .then((res) => {
        delete this.cache[url];
        return res;
      })
      .catch((err) => {
        delete this.cache[url];
        throw err;
      });
    return this.cache[url];
  }
}

const duplicateGetStopper = new DuplicateGetStopper();
